import { buttonBg } from '@synoptic/ui-kit/button/button.css.ts';
import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import { space } from '@synoptic/ui-kit/tokens.ts';
import { typography } from '@synoptic/ui-kit/typography.ts';
import { globalStyle, style } from '@vanilla-extract/css';

export const statusItemContainer = style([
  typography.bodySm,
  {
    display: 'flex',
    alignItems: 'center',
    gap: space.s2,
  },
]);

export const statusItem = style([
  {
    color: themeVars.container.foreground.secondary,
    display: 'flex',
    alignItems: 'center',
    gap: space.s2,
    cursor: 'default',
    whiteSpace: 'nowrap',

    selectors: {
      ['&[data-clickable]']: {
        cursor: 'pointer',
      },
    },
  },
]);

export const statusItemIcon = style([
  {
    borderRadius: 9999,
    padding: space.s4,
    backgroundColor: buttonBg,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    transition: 'background-color .15s',

    selectors: {
      [`${statusItem}:hover &`]: {
        backgroundColor: themeVars.button.tertiary.background.hover,
      },
      [`${statusItem}[data-clickable]:active &`]: {
        backgroundColor: themeVars.button.tertiary.background.active,
      },
    },
  },
]);

export const statusItemIconAfter = style([
  {
    color: themeVars.container.foreground.tertiary,
    width: 24,
    height: 24,
    padding: space.s4,
  },
]);

globalStyle(`${statusItemIcon} svg`, {
  width: 16,
  height: 16,
});

export const statusItemTooltipContent = style([
  {
    textAlign: 'center',
  },
]);
